import { Search } from "General/global-js/search.js";

var MetanavSearch = (function() {
  function manageActiveState() {
    $search.removeClass("metanav__search--inactive").addClass("metanav__search--active");
    $searchbutton.removeClass("icons-suchen").addClass("icons-pfeil");

    $body.on("click tap", function(e) {
      /* _wasFocusInEvent work around to prevent menu closing in mobile on first click :( */
      if (_wasFocusInEvent !== true) {
        handleOutsideClick(e);
      } else {
        _wasFocusInEvent = false;
      }
    });
  }

  function manageInactiveState() {
    $search.removeClass("metanav__search--active").addClass("metanav__search--inactive");
    $searchbutton.removeClass("icons-pfeil").addClass("icons-suchen");

    if ($searchbutton.hasClass("searchform__submit--active") && !isDesktop()) {
      $searchbutton.removeClass("searchform__submit--active");
    }

    if ($search.find(".error-msg").length) {
      Search.removeError($search);
    }
  }

  function closeOtherDropdowns() {
    //close login/signout if exists and open
    if (collapsibles.length) {
      collapsibles.each(function() {
        $(this).removeClass("show");
        $(this).prev().attr("aria-expanded", "false");
      });
    }
  }

  function handleOutsideClick(e) {
    _active = $search.hasClass("metanav__search--active");
    $target = $(e.target);

    if (_active === true && $target.closest(".searchform, .searchform__input, .searchform__submit").length === 0) {
      manageInactiveState();
      $body.off("click tap");
    }
  }

  function bindEvents() {

    $searchinput.on("focusin", function() {
      _wasFocusInEvent = true;
      manageActiveState();
    }).on("keydown", function(e) {
      if (e.shiftKey && e.keyCode === 9) {
        manageInactiveState();
      }
    }).on("input", function() {
      if ($search.find(".error-msg").length && $search.find(".searchform__input").val() !== "") {
        Search.removeError($search);
      }
    });

    $searchbutton.on("keydown", function(e) {
      if (e.keyCode == 9) {
        manageInactiveState();
      }
    });

    //Desktop only
    $searchbutton.on("focusin click", function() {
      if (isDesktop()) {
        _wasFocusInEvent = true;
        manageActiveState();
      }
    });

    //Tablet and Mobile
    $searchbutton.on("focusin tap click", function() {
      if (!isDesktop()) {
        setTimeout(function() {
          $searchbutton.addClass("searchform__submit--active");
        }, 100);
        if (!$search.hasClass("metanav__search--active")) {
          $searchinput.focus();
        }
      }
    }).on("blur", function() {
      if (!isDesktop()) {
        if (!$searchbutton.hasClass("searchform__submit--active")) {
          manageInactiveState();
        }
      }
    });

    $searchinput.on("focusin", function() {
      if (!isDesktop()) {
        closeOtherDropdowns();
      }
    });

    $searchform.on("submit", function(e) {
      if (!isDesktop()) {
        if (!$searchbutton.hasClass("searchform__submit--active")) {
          e.preventDefault();
        } else {
          Search.validateForm(e, $search, err_msg);
        }
      } else {
        Search.validateForm(e, $search, err_msg);
      }
    });
  }

  function isDesktop() {
    return $body.hasClass("desktop");
  }

  function init() {
    $body = $("body");

    $search = $("#headerMetaNavigationSearch");
    $searchform = $search.find(".searchform form");
    $searchinput = $search.find(".searchform__input");
    $searchbutton = $search.find(".searchform__submit");
    $searchresultsnumb = $searchform.find(".searchform__input-results");

    collapsibles = $("header .header__row").find(".collapse");

    err_msg = $searchinput.attr("data-err-required");

    bindEvents();

    $searchresultsnumb.val(Search.calcResultsNumber());
  }

  var $search, $searchform, $searchinput, $searchbutton, $target, $body, $searchresultsnumb, collapsibles, _active, err_msg, _wasFocusInEvent = false;

  return {
    init: init
  };

})();

export { MetanavSearch };
